// 1. IMPORTS
import axios from 'axios'

// 2. CONSTANTS
// Temporary local endpoint registered in @fake-db/pages/station-warnings.
// Supports warnings of any type; the current sample represents camera warnings.
// Replace this service implementation with the real API when available.
export const STATION_WARNINGS_ENDPOINT = '/mock/station-warnings/daily'

// 4. API CALLS
class StationWarningsService {
  /** Response: { thisMonth: [{ date: 'YYYY-MM-DD', warningCount: number }], lastMonth: [...] } */
  static async getDailyWarnings() {
    const response = await axios.get(STATION_WARNINGS_ENDPOINT)
    return response.data
  }
}

// 9. EXPORT
export default StationWarningsService